<template>
  <div class="price-container">
    <MdTypography
      data-qa-id="font-display-styles--price"
      tag="div"
      color="spirits--900"
      variant="body2--regular"
    >
      {{ price }}
    </MdTypography>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { MdTypography } from '@antiqua-dls/vue-components'

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const { data } = props.params
const price = computed(() => {
  return data['price'] || 0
})
</script>

<style lang="scss">
.price-container {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: flex-end;
}
</style>
